export function getPreferenceLabel(pref: {
  name?: string | null;
  format: string;
  detailLevel: string;
  customInstructions?: string | null;
}): string {
  if (pref.name) return pref.name;
  const format = pref.format === 'bullet_points' ? 'Bullets' : 'Paragraph';
  const detail =
    pref.detailLevel.charAt(0).toUpperCase() + pref.detailLevel.slice(1);
  return `${format} / ${detail}${pref.customInstructions ? ' + Custom' : ''}`;
}
